import axios from 'axios';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

// const apiUrl = process.env.REACT_APP_API_URL;

export const fetchDonationTypeApi = async (url: string): Promise<any> => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.get(`${url}/DonationType/GetDonationType`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching donation types from:", `${url}/DonationType/GetDonationType`, error);
    throw error;
  }
};

